/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MDInput
import { Skeleton } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import MDInputRoot from "components/MDInput/MDInputRoot";

const MDInput = forwardRef(({
  error = false,
  success = false,
  disabled = false,
  loading = false,
  multiline = false,
  ...rest }, ref) => {
  if (loading)
    return (
      <Skeleton variant="rectangular" height={pxToRem(45)} sx={{ borderRadius: 1 }} />
    )
  return (
    <MDInputRoot {...rest}
      ref={ref}
      multiline={multiline}
      ownerState={{ error, success, disabled, multiline }} />
  )
});


// Typechecking props for the MDInput
MDInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default MDInput;
